<template>
  <div id="questions">
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <h1>Question Stats</h1>
      </v-row>
    </v-container>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="4" md="8">
          
            <v-card-text>
              <v-row align="center" >
                <v-col cols="6">
                 
                     <v-btn color="primary text-center"  @click="goBack">Back</v-btn>
                </v-col>
               
              </v-row>
            </v-card-text>
          
        </v-col>
      </v-row>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="4" md="8">
          <v-card dark v-if="question !== null">
            <v-card-text>
              <v-row align="center" >
                <v-col cols="12" class="nopadd">
                  <v-card-title class="headline text-start stats">Stats All Up</v-card-title>
                </v-col>
              </v-row>
              <v-row align="center" class="mt-3 topblock">
                <div class="alagblock">
                  <v-card class="mx-auto" max-width="344" outlined>
                    <v-card-subtitle class="removpadbottom">Attempts</v-card-subtitle>
                    <v-card-title class="headline removpadbottom">
                      {{question.all_attempts}}
                    </v-card-title>
                  </v-card>
                </div>
                <div class="alagblock">
                  <v-card class="mx-auto" max-width="344" outlined>
                    <v-card-subtitle class="removpadbottom">Correct</v-card-subtitle>
                    <v-card-title class="headline removpadbottom">
                      {{question.all_correct_attempts}}
                    </v-card-title>
                  </v-card>
                </div>
                <div class="alagblock">
                  <v-card class="mx-auto" max-width="344" outlined>
                    <v-card-subtitle class="removpadbottom">Incorrect</v-card-subtitle>
                    <v-card-title class="headline removpadbottom">
                      {{question.all_wrong_attempts}}
                    </v-card-title>
                  </v-card>
                </div>
                <div class="alagblock">
                  <v-card class="mx-auto" max-width="344" outlined>
                    <v-card-subtitle class="removpadbottom">% correct</v-card-subtitle>
                    <v-card-title class="headline removpadbottom">
                      {{question.all_correct_attempts_percent}}
                    </v-card-title>
                  </v-card>
                </div>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="4" md="8">
          <v-card dark v-if="question !== null">
            <v-card-text>
              <v-row align="center" >
                <v-col cols="12" class="nopadd">
                  <v-card-title class="headline text-start stats">Stats LAST 200 </v-card-title>
                </v-col>
              </v-row>
              <v-row align="center" class="d-flex mt-3">
                <div class="alagblock">
                  <v-card class="mx-auto" max-width="344" outlined>
                    <v-card-subtitle class="removpadbottom">Attempts</v-card-subtitle>
                    <v-card-title class="headline removpadbottom">
                      {{question.last_200_attempts}}
                    </v-card-title>
                  </v-card>
                </div>
                <div class="alagblock">
                  <v-card class="mx-auto" max-width="344" outlined>
                    <v-card-subtitle class="removpadbottom">Correct</v-card-subtitle>
                    <v-card-title class="headline removpadbottom">
                      {{question.last_200_correct_attempts}}
                    </v-card-title>
                  </v-card>
                </div>
                <div class="alagblock">
                  <v-card class="mx-auto" max-width="344" outlined>
                    <v-card-subtitle class="removpadbottom">Incorrect</v-card-subtitle>
                    <v-card-title class="headline removpadbottom">
                      {{question.last_200__wrong_attempts}}
                    </v-card-title>
                  </v-card>
                </div>
                <div class="alagblock">
                  <v-card class="mx-auto" max-width="344" outlined>
                    <v-card-subtitle class="removpadbottom">% correct</v-card-subtitle>
                    <v-card-title class="headline removpadbottom">
                      {{question.last_200_correct_attempts_percent}}
                    </v-card-title>
                  </v-card>
                </div>
                <!--v-if="question.last_200_correct_attempts > 199"-->
                <div class="alagblock" >
                  <v-card class="mx-auto" max-width="344" outlined>
                    <v-card-subtitle class="removpadbottom">Current Level</v-card-subtitle>
                    <v-card-title class="headline removpadbottom">
                      <v-select class="difficulty" hide-details :items="difficulty"  v-model="question.difficulty"></v-select> 
                    </v-card-title>
                  </v-card>
                </div>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="4" md="8">
          <v-card dark v-if="question !== null">
            <v-card-text>
              <v-row align="center">
                <v-col cols="12">
                  <v-card-title class="headline text-start">
                    <v-text-field v-model="question.question" label="Question"></v-text-field>
                  </v-card-title>
                <!-- 
                  <v-card-subtitle
                    class="text-start title text-uppercase font-weight-light blue--text"
                  >
                    {{question.keyword_1}}
                    <v-icon>mdi-chevron-right</v-icon>
                    {{question.keyword_2}}
                  </v-card-subtitle>
                -->
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3">
                  <v-card class="mx-auto" max-width="344" outlined>
                    <v-card-title class="headline">
                      A.
                      <v-icon
                        v-if="question.answer == 'A'"
                        class="green--text text--accent-3"
                      >mdi-check</v-icon>
                      <v-icon v-else class="red--text">mdi-close</v-icon>
                    </v-card-title>
                    <v-card-subtitle>
                      <v-text-field v-model="question.option_a" label="Option A"></v-text-field>
                    </v-card-subtitle>
                    <div class="text-center">
                      <input type="radio" v-model="question.answer" value="A" />
                    </div>
                  </v-card>
                </v-col>
                <v-col cols="3">
                  <v-card class="mx-auto" max-width="344" outlined>
                    <v-card-title class="headline text-start">
                      B.
                      <v-icon
                        v-if="question.answer == 'B'"
                        class="green--text text--accent-3"
                      >mdi-check</v-icon>
                      <v-icon v-else class="red--text">mdi-close</v-icon>
                    </v-card-title>
                    <v-card-subtitle>
                      <v-text-field v-model="question.option_b" label="Option B"></v-text-field>
                    </v-card-subtitle>
                    <div class="text-center">
                      <input type="radio" v-model="question.answer" value="B" />
                    </div>
                  </v-card>
                </v-col>
                <v-col cols="3">
                  <v-card class="mx-auto" max-width="344" outlined>
                    <v-card-title class="headline text-start">
                      C.
                      <v-icon
                        v-if="question.answer == 'C'"
                        class="green--text text--accent-3"
                      >mdi-check</v-icon>
                      <v-icon v-else class="red--text">mdi-close</v-icon>
                    </v-card-title>
                    <v-card-subtitle>
                     <v-text-field v-model="question.option_c" label="Option C"></v-text-field>
                    </v-card-subtitle>
                    <div class="text-center">
                      <input type="radio" v-model="question.answer" value="C" />
                    </div>
                  </v-card>
                </v-col>
                <v-col cols="3">
                  <v-card class="mx-auto" max-width="344" outlined>
                    <v-card-title class="headline text-start">
                      D.
                      <v-icon
                        v-if="question.answer == 'D'"
                        class="green--text text--accent-3"
                      >mdi-check</v-icon>
                      <v-icon v-else class="red--text">mdi-close</v-icon>
                    </v-card-title>
                    <v-card-subtitle>
                     <v-text-field v-model="question.option_d" label="Option D"></v-text-field>
                    </v-card-subtitle>
                    <div class="text-center">
                      <input type="radio" v-model="question.answer" value="D" />
                    </div>
                  </v-card>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3">
                  <v-card class="mx-auto" max-width="344" outlined>
                    <v-card-title class="headline">
                      USA
                      <v-icon v-if="question.usa === 1" class="green--text text--accent-3">mdi-check</v-icon>
                      <v-icon v-else class="red--text">mdi-close</v-icon>
                    </v-card-title>
                  </v-card>
                </v-col>
                <v-col cols="3">
                  <v-card class="mx-auto" max-width="344" outlined>
                    <v-card-title class="headline text-start">
                      AUS
                      <v-icon
                        v-if="question.aust === 1"
                        class="green--text text--accent-3"
                      >mdi-check</v-icon>
                      <v-icon v-else class="red--text">mdi-close</v-icon>
                    </v-card-title>
                  </v-card>
                </v-col>
                <v-col cols="3">
                  <v-card class="mx-auto" max-width="344" outlined>
                    <v-card-title class="headline text-start">
                      UK
                      <v-icon v-if="question.uk === 1" class="green--text text--accent-3">mdi-check</v-icon>
                      <v-icon v-else class="red--text">mdi-close</v-icon>
                    </v-card-title>
                  </v-card>
                </v-col>
                <v-col cols="3">
                  <v-card class="mx-auto" max-width="344" outlined>
                    <v-card-title class="headline text-start">
                      NZ
                      <v-icon v-if="question.nz === 1" class="green--text text--accent-3">mdi-check</v-icon>
                      <v-icon v-else class="red--text">mdi-close</v-icon>
                    </v-card-title>
                  </v-card>
                </v-col>
                <v-col cols="3">
                  <v-card class="mx-auto" max-width="344" outlined>
                    <v-card-title class="headline text-start">
                      ALL
                      <v-icon v-if="question.all === 1" class="green--text text--accent-3">mdi-check</v-icon>
                      <v-icon v-else class="red--text">mdi-close</v-icon>
                    </v-card-title>
                  </v-card>
                </v-col>
              </v-row>
              <!-- 
              <v-row>
                <v-col cols="12" sm="4" md="12">
                  <v-select :items="difficulty" label="Difficulty" v-model="question.difficulty"></v-select> 
                </v-col> 
              </v-row>
              -->
              <v-row>
                <v-col class="text-right" cols="12" sm="4" md="12">
                  {{savetext}}
                  <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                </v-col> 
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";

Vue.use(VueAxios, axios);

axios.defaults.baseURL = process.env.VUE_APP_BASEAPI;

export default {
  name: "Questions",
  data() {
    return {
      questionId: "",
      question: null,
      error: false,
      correctAnswers: 0,
      incorrectAnswers: 0,
      attempts: 0,
      difficulty:["Easy","Medium","Hard","Difficult","Very Difficult"],
      savetext:''
    };
  },
  mounted() {
   let questionId = this.$route.params.questionid;
   this.getQuestion(questionId);
    //console.log(this.$route.params.questionid);
  },
  computed: {},
  methods: {
      goBack() {
        this.$router.go(-1)
      },
    save(){
        var questionid = this.question.id;
        var question   = this.question.question;
        var optiona    = this.question.option_a;
        var optionb    = this.question.option_b;
        var optionc    = this.question.option_c;
        var optiond    = this.question.option_d;
        
        this.$store.dispatch("updateQuestion",
          {
            "id":questionid,
            "question":question,
            "optiona":optiona,
            "optionb":optionb,
            "optionc":optionc,
            "optiond":optiond,
            "answer" :this.question.answer,
            "difficulty":this.question.difficulty
          }).then((response) => {
           this.savetext = response.data.message;
        });
    },
    getQuestion(questionId) {
      /*if (this.questionId === "") {
        this.error = true;
        return;
      } else {
        this.error = false;
      }*/
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");
      Vue.axios
        .get("game/admin/questionstats/" +questionId)
        .then(response => {
          this.question = response.data.data[0];
          this.correctAnswers = 0;
          this.incorrectAnswers = 0;
          this.attempts = 0;
        //   console.log(this.question.user_answer);
          for (let key in this.question.user_answer) {
            // console.log(key, this.question.user_answer[key]);
            if(this.question.user_answer[key].answered_correctly == true) {
                this.correctAnswers = this.correctAnswers+1;
            } else {
                this.incorrectAnswers = this.incorrectAnswers+1;
            }
          }
          this.attempts = Object.keys(this.question.user_question).length;
          this.error = false;
        })
        .catch(error => {
          console.log(error);
          this.question = null;
          this.correctAnswers = 0;
          this.incorrectAnswers = 0;
          this.attempts = 0;
          //   this.error = false;
        });
    }
  }
};
</script>

<style scoped>
.container.fill-height > .row {
  max-width: initial;
}
.headline.stats{line-height:0;}
.nopadd{padding:0;}
.removpadbottom{padding-bottom:0;}
.headline.removpadbottom{padding-top:0;}
.v-card__subtitle.removpadbottom{padding-top:5px;text-align:left;padding-right:0;padding-left:8px;}
.alagblock {flex: 0 0 19%; margin-left: 5px;}
.difficulty{padding-top: 0;margin-top: 0;}
</style>